export enum CSOrVendorComments {
  Brand,
  CS,
}

export enum MedalType {
  Gold = 'Gold',
  Silver = 'Silver',
}

export enum ReviewStatus {
  InProcess = 0,
  ForReview = 1,
  Rejected = 2,
  Approved = 3,
}

export enum TopReviewType {
  TopCriticalReview = 'topCriticalReview',
  TopPositiveReview = 'topPositiveReview',
}

export enum ReviewImageType {
  InReviewList,
  InPendingReview,
  InTopReview,
}

export interface ISummary {
  reviewCount: number;
  imageCount: number;
  answerCount: number;
  helpfulCount: number;
}

export interface IImage {
  reviewId: string;
  assetId: string;
  isClean?: boolean;
  paths: {
    l: string;
    m: string;
    s: string;
  };
}

export interface ICSOrVendorComments {
  content: string;
  postedDateLocalized: string;
}

export interface IBadge {
  type: MedalType;
  name: string;
  description: string;
  title: string;
}

export interface ILanguages {
  languageCode: string;
  languageName: string;
  count: number;
}

export interface IReview {
  id: string;
  customerNickname: string;
  customerProfileLink: string;
  profileImageUrl: string;
  summary: ISummary; // four icon number
  badge?: IBadge | null;
  ratingValue: number;
  reviewTitle: string; // review title
  shareUrl: string; // title share url
  postedDateLocalized: string; // post date
  reviewText: string; // review text
  verifiedPurchase: boolean; // verified purchase
  hasRewarded: boolean; // rewarded
  images?: IImage[];
  helpfulYes: number; // helpful yes
  helpfulNo: number; // helpful no
  hasThumbsUp?: boolean | null; // helpful
  vendorComments?: ICSOrVendorComments | null;
  customerServiceComments?: ICSOrVendorComments | null;
  languageCode: string;
  translatedTo: string;
  translatedToLanguageName: string;
  languageName: string;
  country?: string;
}

export const defaultReview = {
  id: '',
  customerNickname: '',
  customerProfileLink: '',
  profileImageUrl: '',
  summary: {
    reviewCount: 0,
    imageCount: 0,
    answerCount: 0,
    helpfulCount: 0,
  },
  badge: null,
  ratingValue: 0,
  reviewTitle: '',
  shareUrl: '',
  postedDateLocalized: '',
  reviewText: '',
  verifiedPurchase: false,
  hasRewarded: false,
  images: [],
  helpfulYes: 0,
  helpfulNo: 0,
  hasThumbsUp: null,
  vendorComments: null,
  customerServiceComments: null,
  languageCode: '',
  translatedTo: '',
  translatedToLanguageName: '',
  languageName: '',
  country: '',
};

export interface IReviewSummary {
  averageRating: number;
  calculatedRating: number;
  count: number;
  processItems: {
    count: number;
    percentage: number;
    value: number;
  }[];
  topPositiveReview: IReview | null;
  topCriticalReview: IReview | null;
  languages: ILanguages[];
}
export const defaultReviewSummary = {
  averageRating: 0,
  calculatedRating: 0,
  count: 0,
  processItems: [],
  languages: [],
  topPositiveReview: null,
  topCriticalReview: null,
};

export interface IReviewPending {
  id: string;
  status: ReviewStatus;
  isFrozen: boolean;
  ratingValue: number; // rating value
  reviewTitle: string; // review title
  reviewText: string; // review text
  images: IImage[];
  verifiedPurchase: boolean; // verified purchase
  hasRewarded: boolean; // rewarded
  postedDateLocalized: string; // postedDateLocalized
}

export const defaultReviewPending = {
  id: '',
  status: ReviewStatus.InProcess,
  isFrozen: false,
  ratingValue: 0,
  reviewTitle: '',
  reviewText: '',
  images: [],
  verifiedPurchase: false,
  hasRewarded: false,
  postedDateLocalized: '',
};

export interface IReviewImageList {
  items: IImage[];
  totalCount: number;
}
